import { gql, useSubscription } from "@apollo/client";
import { ListenToUpdateZoneSubscription, Zone } from "../../../../API";
import { LISTEN_UPDATE_ZONE } from "../../../../common/operations/subscriptions";
import { successNotification } from "../../../../common/variables/notification";

export const useListenToUpdateZone = (zoneId?: string) => {
  const { data, loading, error } =
    useSubscription<ListenToUpdateZoneSubscription>(LISTEN_UPDATE_ZONE, {
      fetchPolicy: "no-cache",
      variables: { id: zoneId },
      shouldResubscribe: true,

      onData: ({ client, data: result }) => {
        const payload = result.data?.listenToUpdateZone;

        if (!payload) return;

        const cacheId = `Zone:${payload.deviceId}#${payload.id}`;

        const existing = client.cache.readFragment<Zone>({
          id: cacheId,
          fragment: gql`
            fragment ZoneFragment on Zone {
              id
              status
            }
          `,
        });

        const statusChanged = existing?.status !== payload.status;

        client.cache.writeQuery({
          query: LISTEN_UPDATE_ZONE,
          variables: { id: zoneId },
          data: { listenToUpdateZone: payload },
        });

        let msg = `Zone ${payload.name} is updated`;

        if (statusChanged) {
          msg = payload.status
            ? `Zone ${payload.name} is enabled`
            : `Zone ${payload.name} is disabled`;
        }

        successNotification(msg);
      },
    });

  if (error) {
    console.error("Subscription error:", error);
  }

  return { data, loading, error } as const;
};
